export default __webpack_public_path__ + "static/media/bg.5776f501.png";